import './Buttons.css'


const Button = ({
    txt, 
    click = () => { console.error('Nie podano funkcji klika')}, 
    type = 'button', 
    styles= {} 
}) => {


    const handleClick = (e) => {
        click(e)
    }

    return(
        <button 
            className='panel-custom-btn' 
            onClick={e => handleClick(e)}
            style={styles}
            type={type}
        >
            {txt}
        </button>
    )
}

export default Button